import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay, Keyboard, A11y } from 'swiper/modules';

export default function initHomeHeroCarousel() {
	const hero = document.querySelector('.home-hero--carousel');
	if (!hero) return;
	if (hero.dataset.heroInitialized) return;
	hero.dataset.heroInitialized = 'true';

	const swiperEl = hero.querySelector('.home-hero__slides.swiper');
	if (!swiperEl) return;

	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	const autoplayEnabled = hero.dataset.autoplay === 'true' && !prefersReducedMotion;
	const interval = parseInt(hero.dataset.interval, 10) || 6000;
	const pauseOnHover = hero.dataset.pauseOnHover === 'true';

	const paginationEl = hero.querySelector('.home-hero__pagination');

	const swiper = new Swiper(swiperEl, {
		modules: [EffectFade, Pagination, Autoplay, Keyboard, A11y],
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: prefersReducedMotion ? 0 : 600,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		watchSlidesProgress: true,
		autoplay: autoplayEnabled
			? { delay: interval, disableOnInteraction: false, pauseOnMouseEnter: pauseOnHover }
			: false,
		pagination: paginationEl
			? { el: paginationEl, clickable: true }
			: false,
		keyboard: { enabled: true, onlyInViewport: true },
		a11y: {
			enabled: true,
			paginationBulletMessage: 'Go to slide {{index}}',
		},
	});

	// Pause when tab hidden; resume on return.
	document.addEventListener('visibilitychange', () => {
		if (!swiper.autoplay) return;
		if (document.hidden) swiper.autoplay.stop();
		else if (autoplayEnabled) swiper.autoplay.start();
	});

	// Pause autoplay while focus is inside the hero (a11y SC 2.2.2)
	hero.addEventListener('focusin', () => {
		if (swiper.autoplay && autoplayEnabled) swiper.autoplay.stop();
	});
	hero.addEventListener('focusout', (e) => {
		if (!hero.contains(e.relatedTarget) && swiper.autoplay && autoplayEnabled) {
			swiper.autoplay.start();
		}
	});

	// Each slide transition: prevent off-screen slide content from receiving focus.
	// Background videos auto-play on the active slide unless the user has
	// manually paused them via .btn-pause-bg-video (tracked via aria-pressed).
	const updateSlideFocus = () => {
		const slides = swiperEl.querySelectorAll('.swiper-slide');
		slides.forEach((slide) => {
			const isActive = slide.classList.contains('swiper-slide-active');
			const focusables = slide.querySelectorAll('a, button, input, [tabindex]');
			focusables.forEach((el) => {
				if (el.closest('.btn-pause-bg-video')) return;
				el.setAttribute('tabindex', isActive ? '0' : '-1');
			});

			const pauseBtn = slide.querySelector('.btn-pause-bg-video');
			const userPaused = pauseBtn?.getAttribute('aria-pressed') === 'true';

			slide.querySelectorAll('video').forEach((video) => {
				if (isActive && !userPaused) {
					try { video.play().catch(() => {}); } catch (e) {}
				} else if (!isActive) {
					try { video.pause(); } catch (e) {}
				}
			});
		});
	};

	swiper.on('slideChangeTransitionEnd', updateSlideFocus);
	swiper.on('init', updateSlideFocus);
	updateSlideFocus();
}
